import { DialogModule } from '../validation/schema/v1/story';


/**
 * This utility function makes sure any dev links '.alpha.pnk.one' gets replaced 
 * with prod '.alpha.storyverse.xyz'
 */
const DEV_REGEX = /.pnk.one/g;
const BETA_REGEX = /.beta/g;

const PROD_SUFFIX = '.storyverse.xyz';

export const ensureProdLinks = <T>(story: T): T => {
  return JSON.parse(JSON.stringify(story).replace(DEV_REGEX, PROD_SUFFIX).replace(BETA_REGEX, ''));
};
